function importAll(r) {
    return r.keys().map(r);
}
  
const Poland_H = importAll(require.context('../assets/photos/Poland_H', false, /\.(png|jpe?g|svg)$/));
    
export default Poland_H;